import accountsDataService from "../../../services/accountsDataService";
import { type UpdateParams, type Dispatcher } from "../../../../../interfaces";
import { SortingDirection } from "enums";
import { fetchBegin, fetchFailure, fetchSuccess } from "../slices/allAccountsOverviewSlice";
import backgroundTask from "features/BackgroundTasks/backgroundTask";
import { addOperationV1 } from "features/BackgroundTasks/state/backgroundTasksActions";
import { sendTransientNotification } from "features/Notifications/state/notificationsActions";
import { type RootState } from "features/Application/globaltypes/redux";
import { formatFilters } from "utils/filterMapUtils";
import { FilterType, type GenericFiltersMap } from "utils/filterUtils";
import type { FiltersEnum } from "../../types";

interface FetchAccountsParams {
  skip?: number;
  take?: number;
  orderProp?: string;
  orderDirection?: SortingDirection;
  searchText?: string;
  ids?: number[];
  filters?: GenericFiltersMap<FiltersEnum>;
}

export const fetchAccounts =
  ({
    skip,
    take,
    orderProp = "",
    orderDirection = SortingDirection.Ascending,
    searchText,
    ids,
    filters,
  }: FetchAccountsParams) =>
  async (dispatch: Dispatcher, getState: () => RootState) => {
    dispatch(fetchBegin());
    const localFilters = filters ?? getState().accounts.overview.filters.appliedFilter;
    try {
      const { items, itemsCount } = await accountsDataService.getAccounts(
        skip,
        take,
        orderProp,
        orderDirection,
        searchText,
        formatFilters(localFilters, {
          tags: FilterType.Array,
          dateCreated: FilterType.DateRange,
          accountTypeIds: FilterType.Value,
        }),
        ids,
      );

      dispatch(
        fetchSuccess({
          items,
          totalCount: itemsCount,
        }),
      );
    } catch (error) {
      dispatch(fetchFailure(error));
    }
  };

export const deleteAccountThunk = (accountId: number, accountName: string) => async (dispatch: Dispatcher) => {
  const task: UpdateParams = {
    id: "DeleteAccount",
    title: `Deleting account '${accountName}'`,
    successTransientMessage: `Account '${accountName}' has been deleted!`,
    failureTransientMessage: `Account '${accountName}' deletion failed!`,
    indeterminate: true,
    getMessageIds: async () => {
      const messageId = await accountsDataService.deleteAccount(accountId);
      return [messageId];
    },
  };
  backgroundTask.updateEntity(task, {
    addOperation: (params) => dispatch(addOperationV1(params)),
    sendTransientNotification: (payload) => dispatch(sendTransientNotification(payload)),
  });
};
